(() => {
  const cartPage = document.querySelector('[data-cart-page]');
  if (!cartPage) return;

  const formatMoney = (cents) => {
    if (window.theme && typeof window.theme.formatMoney === 'function') {
      return window.theme.formatMoney(cents);
    }
    const formattedNum = new Intl.NumberFormat('id-ID', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(cents / 100);
    return `IDR ${formattedNum}`;
  };

  const setMoney = (el, cents) => {
    if (!el) return;
    el.innerHTML = formatMoney(cents);
  };

  const syncCheckoutState = () => {
    const rows = Array.from(document.querySelectorAll('[data-cart-item]'));
    const hasPreorder = rows.some((row) => row.dataset.fulfillment === 'preorder');
    const hasReady = rows.some((row) => row.dataset.fulfillment === 'ready');
    const mixed = hasPreorder && hasReady;
    const checkoutBtn = document.getElementById('CartCheckoutBtn');
    const mixNotice = document.getElementById('CartMixNotice');
    const preorderNotice = document.getElementById('CartPreorderNotice');

    if (checkoutBtn) {
      checkoutBtn.disabled = mixed || (!hasPreorder && !hasReady);
    }
    if (mixNotice) mixNotice.hidden = !mixed;
    if (preorderNotice) preorderNotice.hidden = mixed || !hasPreorder;
  };

  const updateCartLine = async (key, quantity) => {
    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          id: key,
          quantity: quantity
        })
      });

      if (response.ok) {
        const cart = await response.json();

        // Update header count
        if (window.updateHeaderCartCount) {
          window.updateHeaderCartCount(cart.item_count);
        }

        // If cart is completely empty, reload page to show empty state
        if (cart.item_count === 0) {
          window.location.reload();
          return;
        }

        const stickyTotal = document.getElementById('CartStickyTotal');
        const soldOutRows = document.querySelectorAll('.cart-item--sold-out');
        const soldOutKeys = Array.from(soldOutRows).map((row) => row.dataset.lineKey);

        if (stickyTotal) {
          const activeTotal = cart.items
            .filter((item) => !soldOutKeys.includes(item.key))
            .reduce((sum, item) => sum + item.final_line_price, 0);

          setMoney(stickyTotal, activeTotal);
        }

        const itemRow = document.querySelector(`[data-cart-item][data-line-key="${key}"]`);
        if (quantity === 0) {
          if (itemRow) itemRow.remove();
        } else {
          const updatedItem = cart.items.find((item) => item.key === key);
          if (updatedItem && itemRow) {
            const input = itemRow.querySelector('.cart-qty-stepper__input');
            if (input) input.value = updatedItem.quantity;

            const totalEl = itemRow.querySelector('.cart-item__total');
            if (totalEl) setMoney(totalEl, updatedItem.final_line_price);
          }
        }

        syncCheckoutState();
      }
    } catch (err) {
      console.error('Error updating cart', err);
    }
  };

  // Quantity Stepper Click
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.cart-qty-stepper__btn');
    if (!btn) return;

    const stepper = btn.closest('.cart-qty-stepper');
    const input = stepper ? stepper.querySelector('.cart-qty-stepper__input') : null;
    if (!input) return;

    const key = input.dataset.lineKey;
    let currentVal = parseInt(input.value, 10) || 1;
    const action = btn.dataset.qtyAction;

    if (action === 'increase') {
      currentVal += 1;
    } else if (action === 'decrease') {
      currentVal = Math.max(0, currentVal - 1);
    }

    input.value = currentVal;
    updateCartLine(key, currentVal);
  });

  // Quantity Input Direct Change
  document.addEventListener('change', (e) => {
    const input = e.target.closest('.cart-qty-stepper__input');
    if (!input) return;

    const key = input.dataset.lineKey;
    let val = parseInt(input.value, 10);
    if (isNaN(val) || val < 0) val = 1;
    input.value = val;

    updateCartLine(key, val);
  });

  // Remove Trash Icon Click
  document.addEventListener('click', (e) => {
    const removeBtn = e.target.closest('.cart-item__remove-btn');
    if (!removeBtn) return;

    const key = removeBtn.dataset.removeKey;
    if (key) {
      updateCartLine(key, 0);
    }
  });
})();
